/*
 * This class has been auto-generated by the back end. Look for usages of the library no.invarians.lib.es6facadegenerator.
 */
import {ApiClient} from 'api-client';
import {inject} from 'aurelia-framework';

@inject(ApiClient)
export default class Backend {
    apiClient;

    constructor(apiClient) {
        this.apiClient = apiClient;
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             documentType: '[DocumentType]',
     *             orderType: '[OrderType]',
     *             orderNumber: '[String]'
     *         }
     * Return dto:
     *     {
     *         path: '[String]',
     *         orderNumber: '[String]'
     *     }
     */
    AddVmpTestDocumentCommandHandler_handle(command) {
        return this.apiClient.invoke('AddVmpTestDocumentCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             articleNumber: '[String]',
     *             packagingId: '[PackagingId]',
     *             productId: '[ProductId]',
     *             fractionalVolume: '[BigDecimal]',
     *             epd: '[String]',
     *             gtinConsumerPackaging: '[String]',
     *             gtinDistributionPackaging: '[String]',
     *             vmpArticleNumber: '[String]',
     *             vatCode: '[VatCode]',
     *             batchTracking: '[boolean]',
     *             isAccessibleInCustomerPortal: '[boolean]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    ArticleCrud_create(dto) {
        return this.apiClient.invoke('ArticleCrud', 'create', { dto: dto });
    }

    /**
     * Parameter dto:
     *     articleId:
     *         {

     *         }
     * Return dto:
     *     {
     *         articleId: '[ArticleId]',
     *         articleNumber: '[String]',
     *         packagingName: '[String]',
     *         packagingId: '[PackagingId]',
     *         productName: '[String]',
     *         productId: '[ProductId]',
     *         fractionalVolume: '[BigDecimal]',
     *         epd: '[String]',
     *         gtinConsumerPackaging: '[String]',
     *         gtinDistributionPackaging: '[String]',
     *         vmpArticleNumber: '[String]',
     *         vatCode: '[String]',
     *         batchTracking: '[boolean]',
     *         active: '[boolean]',
     *         isAccessibleInCustomerPortal: '[boolean]'
     *     }
     */
    ArticleCrud_details(articleId) {
        return this.apiClient.invoke('ArticleCrud', 'details', { articleId: articleId });
    }

    /**
     * Parameter dto:
     *     articleId:
     *         {

     *         }
     *     dto:
     *         {
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingId: '[PackagingId]',
     *             productId: '[ProductId]',
     *             fractionalVolume: '[BigDecimal]',
     *             epd: '[String]',
     *             gtinConsumerPackaging: '[String]',
     *             gtinDistributionPackaging: '[String]',
     *             vmpArticleNumber: '[String]',
     *             vatCode: '[VatCode]',
     *             batchTracking: '[boolean]',
     *             active: '[boolean]',
     *             isAccessibleInCustomerPortal: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    ArticleCrud_edit(articleId, dto) {
        return this.apiClient.invoke('ArticleCrud', 'edit', { articleId: articleId, dto: dto });
    }

    /**
     * Parameter dto:
     *     articleId:
     *         {

     *         }
     * Return dto:
     *     {
     *         articleId: '[ArticleId]',
     *         articleEditDto: '[ArticleEditDto]',
     *         canEditProductId: '[boolean]',
     *         canEditFractionalVolume: '[boolean]',
     *         canEditPackagingId: '[boolean]'
     *     }
     */
    ArticleCrud_getForEdit(articleId) {
        return this.apiClient.invoke('ArticleCrud', 'getForEdit', { articleId: articleId });
    }

    /**
     * Parameter dto:
     *     showInactiveArticles:
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    ArticleCrud_index(showInactiveArticles) {
        return this.apiClient.invoke('ArticleCrud', 'index', { showInactiveArticles: showInactiveArticles });
    }

    /**
     * Parameter dto:
     *     query:
     *         {

     *         }
     * Return dto:
     *     {
     *         ruleHeaders: {
     *             displayName: '[String]',
     *             key: '[ArticlePriceRuleKey]'
     *         },
     *         articles: {
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             articleName: '[String]',
     *             rules: {
     *                 articlePriceRuleId: '[ArticlePriceRuleId]',
     *                 key: '[ArticlePriceRuleKey]',
     *                 price: '[Money]'
     *             }
     *         }
     *     }
     */
    ArticlePriceListQueryHandler_handle(query) {
        return this.apiClient.invoke('ArticlePriceListQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {

     *         }
     * Return dto:
     *     void
     */
    AttemptAssignStoreNumberToAllExistingVmpCustomersCommandHandler_handle(command) {
        return this.apiClient.invoke('AttemptAssignStoreNumberToAllExistingVmpCustomersCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             batchNumber: '[int]',
     *             productId: '[ProductId]',
     *             brewDate: '[LocalDate]',
     *             tappingDate: '[LocalDate]',
     *             trackingNote: '[String]',
     *             expiryDate: '[LocalDate]',
     *             rangeOverride: '[RangeEnum]',
     *             reportToHealthDirectorate: '[boolean]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    BatchCrud_create(dto) {
        return this.apiClient.invoke('BatchCrud', 'create', { dto: dto });
    }

    /**
     * Parameter dto:
     *     batchId:
     *         {

     *         }
     * Return dto:
     *     {
     *         batchId: '[BatchId]',
     *         batchNumber: '[int]',
     *         productId: '[ProductId]',
     *         productName: '[String]',
     *         brewDate: '[LocalDate]',
     *         tappingDate: '[LocalDate]',
     *         expiryDate: '[LocalDate]',
     *         trackingNote: '[String]',
     *         rangeOverride: '[RangeEnum]',
     *         reportToHealthDirectorate: '[boolean]',
     *         active: '[boolean]'
     *     }
     */
    BatchCrud_details(batchId) {
        return this.apiClient.invoke('BatchCrud', 'details', { batchId: batchId });
    }

    /**
     * Parameter dto:
     *     batchId:
     *         {

     *         }
     *     dto:
     *         {
     *             batchId: '[BatchId]',
     *             batchNumber: '[int]',
     *             productId: '[ProductId]',
     *             brewDate: '[LocalDate]',
     *             expiryDate: '[LocalDate]',
     *             trackingNote: '[String]',
     *             tappingDate: '[LocalDate]',
     *             rangeOverride: '[RangeEnum]',
     *             reportToHealthDirectorate: '[boolean]',
     *             active: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    BatchCrud_edit(batchId, dto) {
        return this.apiClient.invoke('BatchCrud', 'edit', { batchId: batchId, dto: dto });
    }

    /**
     * Parameter dto:
     *     batchId:
     *         {

     *         }
     * Return dto:
     *     {
     *         batchId: '[BatchId]',
     *         batchEditDto: '[BatchEditDto]',
     *         canEditProductId: '[boolean]',
     *         canEditRangeOverride: '[boolean]'
     *     }
     */
    BatchCrud_getForEdit(batchId) {
        return this.apiClient.invoke('BatchCrud', 'getForEdit', { batchId: batchId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    BatchCrud_getMaxBatchNumber() {
        return this.apiClient.invoke('BatchCrud', 'getMaxBatchNumber', {  });
    }

    /**
     * Parameter dto:
     *     showInactiveCustomers:
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    BatchCrud_index(showInactiveCustomers) {
        return this.apiClient.invoke('BatchCrud', 'index', { showInactiveCustomers: showInactiveCustomers });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             productId: '[ProductId]'
     *         }
     * Return dto:
     *     {
     *         batches: {
     *             id: '[BatchId]',
     *             name: '[String]'
     *         }
     *     }
     */
    BatchesForDropdownQueryHandler_handle(query) {
        return this.apiClient.invoke('BatchesForDropdownQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             productId: '[ProductId]',
     *             articleId: '[ArticleId]',
     *             storageAreaId: '[StorageAreaId]'
     *         }
     * Return dto:
     *     {
     *         batches: {
     *             id: '[BatchId]',
     *             name: '[String]',
     *             inStock: '[Long]',
     *             reserved: '[Long]'
     *         }
     *     }
     */
    BatchesWithInventoryForDropdownQueryHandler_handle(query) {
        return this.apiClient.invoke('BatchesWithInventoryForDropdownQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         beverageTypes: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    BeverageTypesForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('BeverageTypesForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         breweryId: '[BreweryId]',
     *         name: '[String]',
     *         organizationNumber: '[String]',
     *         streetAddress: '[String]',
     *         postalCode: '[String]',
     *         city: '[String]',
     *         phoneNumber: '[String]',
     *         smallBrewery: '[boolean]',
     *         orderConfirmationFromEmail: '[String]',
     *         orderConfirmationCcAddress: '[String]',
     *         notificationEmail: '[String]',
     *         allowNegativeInventory: '[boolean]',
     *         bankAccountNumber: '[String]',
     *         defaultInvoiceCustomersReference: '[String]',
     *         vatRegistered: '[boolean]',
     *         vmpEnableIntegration: '[boolean]',
     *         ehfEnableIntegration: '[boolean]',
     *         pdfEnableIntegration: '[boolean]',
     *         customerPortalEnable: '[boolean]',
     *         customerPortalAbvGuard: '[boolean]',
     *         enablePlainInvoiceExportGui: '[boolean]',
     *         enableTransfers: '[boolean]',
     *         enableBrod2Report: '[boolean]',
     *         invoiceExportFormat: '[InvoiceExportFormat]'
     *     }
     */
    BreweryCrud_details() {
        return this.apiClient.invoke('BreweryCrud', 'details', {  });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             breweryId: '[BreweryId]',
     *             name: '[String]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]',
     *             phoneNumber: '[String]',
     *             smallBrewery: '[boolean]',
     *             orderConfirmationFromEmail: '[String]',
     *             orderConfirmationCcAddress: '[String]',
     *             notificationEmail: '[String]',
     *             allowNegativeInventory: '[boolean]',
     *             bankAccountNumber: '[String]',
     *             defaultInvoiceCustomersReference: '[String]',
     *             vatRegistered: '[boolean]',
     *             customerPortalAbvGuard: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    BreweryCrud_edit(dto) {
        return this.apiClient.invoke('BreweryCrud', 'edit', { dto: dto });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         breweryId: '[BreweryId]',
     *         breweryEditDto: '[BreweryEditDto]'
     *     }
     */
    BreweryCrud_getForEdit() {
        return this.apiClient.invoke('BreweryCrud', 'getForEdit', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             yearMonth: '[YearMonth]'
     *         }
     * Return dto:
     *     {
     *         beerSection: '[BeerSectionDto]',
     *         ciderSection: '[CiderSectionDto]',
     *         readyToDrinkSection: '[ReadyToDrinkSectionDto]',
     *         sodaSection: '[SodaSectionDto]',
     *         energyDrinkSection: '[EnergyDrinkSectionDto]',
     *         waterSection: '[WaterSectionDto]'
     *     }
     */
    BrodReport2QueryHandler_handle(query) {
        return this.apiClient.invoke('BrodReport2QueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             yearMonth: '[YearMonth]'
     *         }
     * Return dto:
     *     {
     *         beer: '[BrodReportBeerDto]',
     *         cider: '[BrodReportCiderDto]',
     *         soda: '[BrodReportSodaDto]',
     *         water: '[BrodReportWaterDto]',
     *         energyDrink: '[BrodReportEnergyDrinkDto]'
     *     }
     */
    BrodReportQueryHandler_handle(query) {
        return this.apiClient.invoke('BrodReportQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             orderId: '[OrderId]',
     *             autoSendOrderConfirmation: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    CancelOrderCommandHandler_handle(command) {
        return this.apiClient.invoke('CancelOrderCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {

     *         }
     * Return dto:
     *     void
     */
    CheckVmpSftpCommandHandler_handle(command) {
        return this.apiClient.invoke('CheckVmpSftpCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             bundleId: '[BundleId]'
     *         }
     * Return dto:
     *     void
     */
    CloseBundleCommandHandler_handle(command) {
        return this.apiClient.invoke('CloseBundleCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             explicitActionableItemId: '[ExplicitActionableItemId]'
     *         }
     * Return dto:
     *     void
     */
    CloseExplicitlyActionableItemCommandHandler_handle(command) {
        return this.apiClient.invoke('CloseExplicitlyActionableItemCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderDocumentType: '[OrderDocumentType]',
     *             id: '[UUID]'
     *         }
     * Return dto:
     *     {
     *         command: '[CreateDeliveryNoteCommandTemplate]'
     *     }
     */
    CreateDeliveryNoteCommandHandler_getTemplate(query) {
        return this.apiClient.invoke('CreateDeliveryNoteCommandHandler', 'getTemplate', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             orderId: '[OrderId]',
     *             deliveryDate: '[LocalDate]',
     *             lines: {
     *                 orderLineId: '[OrderLineId]',
     *                 deliveredQuantity: '[Integer]',
     *                 newAdditionalFields: {
     *                     key: '[String]',
     *                     value: '[String]'
     *                 }
     *             },
     *             newAdditionalFields: {
     *                 key: '[String]',
     *                 value: '[String]'
     *             }
     *         }
     * Return dto:
     *     {

     *     }
     */
    CreateDeliveryNoteCommandHandler_handle(command) {
        return this.apiClient.invoke('CreateDeliveryNoteCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderDocumentType: '[OrderDocumentType]',
     *             id: '[UUID]'
     *         }
     * Return dto:
     *     {
     *         command: '[CreateInvoiceCommandTemplate]',
     *         invoiceTypes: {
     *             VMP: '[InvoiceType]',
     *             EHF: '[InvoiceType]',
     *             PDF: '[InvoiceType]',
     *             $VALUES: '[InvoiceType[]]'
     *         }
     *     }
     */
    CreateInvoiceCommandHandler_getTemplate(query) {
        return this.apiClient.invoke('CreateInvoiceCommandHandler', 'getTemplate', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             invoiceType: '[InvoiceType]',
     *             isCreditNote: '[boolean]',
     *             originalInvoiceNumber: '[String]',
     *             orderId: '[OrderId]',
     *             invoiceDate: '[LocalDate]',
     *             deliveryDate: '[LocalDate]',
     *             dueDate: '[LocalDate]',
     *             bankAccountNumber: '[String]',
     *             isKidNumber: '[boolean]',
     *             requestedBankReference: '[String]',
     *             customersReference: '[String]',
     *             lines: {
     *                 articleId: '[ArticleId]',
     *                 orderLineId: '[OrderLineId]',
     *                 description: '[String]',
     *                 quantity: '[int]',
     *                 thisLineIsPanteSats: '[PanteSats]',
     *                 priceExVat: '[Money]',
     *                 vatCode: '[VatCode]',
     *                 discountRate: '[BigDecimal]'
     *             }
     *         }
     * Return dto:
     *     {

     *     }
     */
    CreateInvoiceCommandHandler_handle(command) {
        return this.apiClient.invoke('CreateInvoiceCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderDocumentType: '[OrderDocumentType]',
     *             id: '[UUID]'
     *         }
     * Return dto:
     *     {
     *         command: '[CreateOrderConfirmationCommandTemplate]',
     *         orderSource: '[OrderSource]'
     *     }
     */
    CreateOrderConfirmationCommandHandler_getTemplate(query) {
        return this.apiClient.invoke('CreateOrderConfirmationCommandHandler', 'getTemplate', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             orderId: '[OrderId]',
     *             deliveryDate: '[LocalDate]',
     *             lines: {
     *                 orderLineId: '[OrderLineId]',
     *                 confirmedQuantity: '[Integer]',
     *                 newAdditionalFields: {
     *                     key: '[String]',
     *                     value: '[String]'
     *                 }
     *             },
     *             newAdditionalFields: {
     *                 key: '[String]',
     *                 value: '[String]'
     *             },
     *             comment: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    CreateOrderConfirmationCommandHandler_handle(command) {
        return this.apiClient.invoke('CreateOrderConfirmationCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             csv: '[InputStream]',
     *             dateFormatPattern: '[String]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             parsedCsvLine: '[ParsedCsvLine]',
     *             registerSaleTemplate: '[RegisterMultipleSalesCommandItemTemplateDto]'
     *         }
     *     }
     */
    CsvParserQueryHandler_handle(query) {
        return this.apiClient.invoke('CsvParserQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         customerAdditionalCodes: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    CustomerAdditionalCodesForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('CustomerAdditionalCodesForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             customerNumber: '[String]',
     *             name: '[String]',
     *             organizationNumber: '[String]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]',
     *             countryCode: '[String]',
     *             phoneNumber: '[String]',
     *             email: '[String]',
     *             emailInvoiceRecipient: '[String]',
     *             note: '[String]',
     *             customerType: '[CustomerType]',
     *             additionalCode: '[String]',
     *             shouldHaveYearlyReportOnEmail: '[boolean]',
     *             vmpStoreNumber: '[String]',
     *             customerPriceGroupId: '[CustomerPriceGroupId]',
     *             isExport: '[boolean]',
     *             discountRate: '[BigDecimal]',
     *             brod2SalesChannel: '[Brod2SalesChannel]',
     *             infinitumKeyKegStartDate: '[LocalDate]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    CustomerCrud_create(dto) {
        return this.apiClient.invoke('CustomerCrud', 'create', { dto: dto });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     * Return dto:
     *     {
     *         customerId: '[CustomerId]',
     *         customerNumber: '[String]',
     *         name: '[String]',
     *         organizationNumber: '[String]',
     *         streetAddress: '[String]',
     *         postalCode: '[String]',
     *         city: '[String]',
     *         countryCode: '[String]',
     *         countryDisplayName: '[String]',
     *         phoneNumber: '[String]',
     *         email: '[String]',
     *         emailInvoiceRecipient: '[String]',
     *         note: '[String]',
     *         customerType: '[CustomerType]',
     *         additionalCode: '[String]',
     *         brod2SalesChannel: '[Brod2SalesChannel]',
     *         shouldHaveYearlyReportOnEmail: '[boolean]',
     *         vmpStoreNumber: '[String]',
     *         customerPriceGroupId: '[CustomerPriceGroupId]',
     *         customerPriceGroupName: '[String]',
     *         isExport: '[boolean]',
     *         discountRate: '[BigDecimal]',
     *         active: '[boolean]',
     *         infinitumKeyKegStartDate: '[LocalDate]'
     *     }
     */
    CustomerCrud_details(customerId) {
        return this.apiClient.invoke('CustomerCrud', 'details', { customerId: customerId });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     *     dto:
     *         {
     *             customerId: '[CustomerId]',
     *             customerNumber: '[String]',
     *             name: '[String]',
     *             organizationNumber: '[String]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]',
     *             countryCode: '[String]',
     *             phoneNumber: '[String]',
     *             email: '[String]',
     *             emailInvoiceRecipient: '[String]',
     *             note: '[String]',
     *             customerType: '[CustomerType]',
     *             additionalCode: '[String]',
     *             brod2SalesChannel: '[Brod2SalesChannel]',
     *             shouldHaveYearlyReportOnEmail: '[boolean]',
     *             vmpStoreNumber: '[String]',
     *             customerPriceGroupId: '[CustomerPriceGroupId]',
     *             isExport: '[boolean]',
     *             discountRate: '[BigDecimal]',
     *             active: '[boolean]',
     *             infinitumKeyKegStartDate: '[LocalDate]'
     *         }
     * Return dto:
     *     void
     */
    CustomerCrud_edit(customerId, dto) {
        return this.apiClient.invoke('CustomerCrud', 'edit', { customerId: customerId, dto: dto });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     * Return dto:
     *     {
     *         customerId: '[CustomerId]',
     *         customerEditDto: '[CustomerEditDto]',
     *         canEditCustomerType: '[boolean]',
     *         canEditInfinitumKeyKegStartDate: '[boolean]'
     *     }
     */
    CustomerCrud_getForEdit(customerId) {
        return this.apiClient.invoke('CustomerCrud', 'getForEdit', { customerId: customerId });
    }

    /**
     * Parameter dto:
     *     showInactiveCustomers:
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    CustomerCrud_index(showInactiveCustomers) {
        return this.apiClient.invoke('CustomerCrud', 'index', { showInactiveCustomers: showInactiveCustomers });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             customerId: '[CustomerId]',
     *             validFromInclusive: '[LocalDate]',
     *             validToInclusive: '[LocalDate]',
     *             type: '[CustomerPermitType]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    CustomerPermitCrud_create(dto) {
        return this.apiClient.invoke('CustomerPermitCrud', 'create', { dto: dto });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     *     customerPermitId:
     *         {

     *         }
     *     dto:
     *         {
     *             customerPermitId: '[CustomerPermitId]',
     *             validFromInclusive: '[LocalDate]',
     *             validToInclusive: '[LocalDate]',
     *             type: '[CustomerPermitType]'
     *         }
     * Return dto:
     *     void
     */
    CustomerPermitCrud_edit(customerId, customerPermitId, dto) {
        return this.apiClient.invoke('CustomerPermitCrud', 'edit', { customerId: customerId, customerPermitId: customerPermitId, dto: dto });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     *     customerPermitId:
     *         {

     *         }
     * Return dto:
     *     {
     *         customerPermitId: '[CustomerPermitId]',
     *         customerPermitEditDto: '[CustomerPermitEditDto]'
     *     }
     */
    CustomerPermitCrud_getForEdit(customerId, customerPermitId) {
        return this.apiClient.invoke('CustomerPermitCrud', 'getForEdit', { customerId: customerId, customerPermitId: customerPermitId });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    CustomerPermitCrud_index(customerId) {
        return this.apiClient.invoke('CustomerPermitCrud', 'index', { customerId: customerId });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             customerId: '[CustomerId]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             articleName: '[String]',
     *             volume: '[BigDecimal]',
     *             abv: '[BigDecimal]',
     *             quantityPrCrate: '[Integer]',
     *             panteSats: '[PanteSats]',
     *             price: '[Money]'
     *         }
     *     }
     */
    CustomerPortalArticleListQueryHandler_handle(query) {
        return this.apiClient.invoke('CustomerPortalArticleListQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderId: '[OrderId]'
     *         }
     * Return dto:
     *     {
     *         orderId: '[OrderId]',
     *         customerId: '[CustomerId]',
     *         orderNumber: '[String]',
     *         orderDate: '[LocalDate]',
     *         createdDateTime: '[LocalDateTime]',
     *         customersReference: '[String]',
     *         commentFromCustomer: '[String]',
     *         orderSource: '[OrderSource]',
     *         lines: {
     *             orderLineId: '[OrderLineId]',
     *             orderLineNumber: '[int]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             articleName: '[String]',
     *             articleVolume: '[BigDecimal]',
     *             articleABV: '[BigDecimal]',
     *             quantity: '[int]',
     *             priceExVat: '[Money]'
     *         }
     *     }
     */
    CustomerPortalOrderDetailsQueryHandler_handle(query) {
        return this.apiClient.invoke('CustomerPortalOrderDetailsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             customerId: '[CustomerId]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             orderId: '[OrderId]',
     *             orderNumber: '[String]',
     *             orderDate: '[LocalDate]',
     *             createdDateTime: '[LocalDateTime]',
     *             customersReference: '[String]'
     *         }
     *     }
     */
    CustomerPortalOrderListQueryHandler_handle(query) {
        return this.apiClient.invoke('CustomerPortalOrderListQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             customerId: '[CustomerId]',
     *             customersReference: '[String]',
     *             commentFromCustomer: '[String]',
     *             items: {
     *                 articleId: '[ArticleId]',
     *                 quantity: '[int]',
     *                 price: '[Money]'
     *             }
     *         }
     * Return dto:
     *     {
     *         orderId: '[OrderId]',
     *         orderNumber: '[String]'
     *     }
     */
    CustomerPortalPurchaseCommandHandler_handle(command) {
        return this.apiClient.invoke('CustomerPortalPurchaseCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             name: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    CustomerPriceGroupCrud_create(dto) {
        return this.apiClient.invoke('CustomerPriceGroupCrud', 'create', { dto: dto });
    }

    /**
     * Parameter dto:
     *     customerPriceGroupId:
     *         {

     *         }
     * Return dto:
     *     {
     *         customerPriceGroupId: '[CustomerPriceGroupId]',
     *         name: '[String]'
     *     }
     */
    CustomerPriceGroupCrud_details(customerPriceGroupId) {
        return this.apiClient.invoke('CustomerPriceGroupCrud', 'details', { customerPriceGroupId: customerPriceGroupId });
    }

    /**
     * Parameter dto:
     *     customerPriceGroupId:
     *         {

     *         }
     *     dto:
     *         {
     *             customerPriceGroupId: '[CustomerPriceGroupId]',
     *             name: '[String]'
     *         }
     * Return dto:
     *     void
     */
    CustomerPriceGroupCrud_edit(customerPriceGroupId, dto) {
        return this.apiClient.invoke('CustomerPriceGroupCrud', 'edit', { customerPriceGroupId: customerPriceGroupId, dto: dto });
    }

    /**
     * Parameter dto:
     *     customerPriceGroupId:
     *         {

     *         }
     * Return dto:
     *     {
     *         customerPriceGroupId: '[CustomerPriceGroupId]',
     *         customerPriceGroupEditDto: '[CustomerPriceGroupEditDto]'
     *     }
     */
    CustomerPriceGroupCrud_getForEdit(customerPriceGroupId) {
        return this.apiClient.invoke('CustomerPriceGroupCrud', 'getForEdit', { customerPriceGroupId: customerPriceGroupId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    CustomerPriceGroupCrud_index() {
        return this.apiClient.invoke('CustomerPriceGroupCrud', 'index', {  });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         customerTypes: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    CustomerTypesForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('CustomerTypesForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     *     dto:
     *         {
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             email: '[String]',
     *             description: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    CustomerUserCrud_create(customerId, dto) {
        return this.apiClient.invoke('CustomerUserCrud', 'create', { customerId: customerId, dto: dto });
    }

    /**
     * Parameter dto:
     *     customerUserId:
     *         {

     *         }
     *     dto:
     *         {
     *             customerUserId: '[CustomerUserId]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             email: '[String]',
     *             description: '[String]',
     *             isEnabled: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    CustomerUserCrud_edit(customerUserId, dto) {
        return this.apiClient.invoke('CustomerUserCrud', 'edit', { customerUserId: customerUserId, dto: dto });
    }

    /**
     * Parameter dto:
     *     customerUserId:
     *         {

     *         }
     * Return dto:
     *     {
     *         customerUserId: '[CustomerUserId]',
     *         customerUserEditDto: '[CustomerUserEditDto]'
     *     }
     */
    CustomerUserCrud_getForEdit(customerUserId) {
        return this.apiClient.invoke('CustomerUserCrud', 'getForEdit', { customerUserId: customerUserId });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    CustomerUserCrud_index(customerId) {
        return this.apiClient.invoke('CustomerUserCrud', 'index', { customerId: customerId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         customers: {
     *             id: '[CustomerId]',
     *             name: '[String]',
     *             customerType: '[CustomerType]',
     *             additionalCode: '[String]',
     *             isDutyFree: '[boolean]'
     *         }
     *     }
     */
    CustomersForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('CustomersForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             deliveryNoteId: '[DeliveryNoteId]'
     *         }
     * Return dto:
     *     {
     *         deliveryNote: '[DeliveryNoteDetailsQueryResultEntity]',
     *         documentRenderings: {
     *             documentRenderingId: '[DocumentRenderingId]',
     *             createdDateTime: '[LocalDateTime]',
     *             filename: '[String]',
     *             mimeType: '[String]'
     *         }
     *     }
     */
    DeliveryNoteDetailsQueryHandler_handle(query) {
        return this.apiClient.invoke('DeliveryNoteDetailsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             documentRenderingId: '[DocumentRenderingId]'
     *         }
     * Return dto:
     *     {
     *         fileBase64: '[String]',
     *         filename: '[String]'
     *     }
     */
    DocumentRenderingFileQueryHandler_handle(query) {
        return this.apiClient.invoke('DocumentRenderingFileQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             transferId: '[TransferId]'
     *         }
     * Return dto:
     *     {
     *         fileBase64: '[String]',
     *         filename: '[String]'
     *     }
     */
    DownloadTransferFileQueryHandler_handle(query) {
        return this.apiClient.invoke('DownloadTransferFileQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     entityName:
     *         {
     *             value: '[byte[]]',
     *             coder: '[byte]',
     *             hash: '[int]',
     *             hashIsZero: '[boolean]',
     *             serialVersionUID: '[long]',
     *             COMPACT_STRINGS: '[boolean]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             REPL: '[char]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]',
     *             LATIN1: '[byte]',
     *             UTF16: '[byte]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    DropdownItemQueryHandler_handle(entityName) {
        return this.apiClient.invoke('DropdownItemQueryHandler', 'handle', { entityName: entityName });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             exciseReportId: '[ExciseReportId]'
     *         }
     * Return dto:
     *     {
     *         value: '[byte[]]',
     *         coder: '[byte]',
     *         hash: '[int]',
     *         hashIsZero: '[boolean]',
     *         serialVersionUID: '[long]',
     *         COMPACT_STRINGS: '[boolean]',
     *         serialPersistentFields: '[ObjectStreamField[]]',
     *         REPL: '[char]',
     *         CASE_INSENSITIVE_ORDER: '[Comparator]',
     *         LATIN1: '[byte]',
     *         UTF16: '[byte]'
     *     }
     */
    DutyCsvReportQueryHandler_handle(query) {
        return this.apiClient.invoke('DutyCsvReportQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             exciseReportId: '[ExciseReportId]'
     *         }
     * Return dto:
     *     {
     *         fileBase64: '[String]',
     *         filename: '[String]'
     *     }
     */
    DutyCsvReportQueryHandler_handleBase64(query) {
        return this.apiClient.invoke('DutyCsvReportQueryHandler', 'handleBase64', { query: query });
    }

    /**
     * Parameter dto:
     *     movementId:
     *         {

     *         }
     * Return dto:
     *     {
     *         movementId: '[MovementId]',
     *         productId: '[ProductId]',
     *         movementType: '[MovementType]',
     *         hasOrder: '[boolean]',
     *         date: '[LocalDate]',
     *         storageAreaId: '[StorageAreaId]',
     *         articleId: '[ArticleId]',
     *         batchId: '[BatchId]',
     *         quantity: '[int]',
     *         customerId: '[CustomerId]',
     *         correspondingSalePeriod: '[String]',
     *         invoiceNumber: '[String]',
     *         comment: '[String]'
     *     }
     */
    EditMovementCommandHandler_getForEdit(movementId) {
        return this.apiClient.invoke('EditMovementCommandHandler', 'getForEdit', { movementId: movementId });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             movement: '[EditMovementDto]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    EditMovementCommandHandler_handle(command) {
        return this.apiClient.invoke('EditMovementCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             movementId: '[MovementId]',
     *             comment: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    EditMovementCommandHandler_revert(command) {
        return this.apiClient.invoke('EditMovementCommandHandler', 'revert', { command: command });
    }

    /**
     * Parameter dto:
     *     localDate:
     *         {
     *             MIN: '[LocalDate]',
     *             MAX: '[LocalDate]',
     *             EPOCH: '[LocalDate]',
     *             serialVersionUID: '[long]',
     *             DAYS_PER_CYCLE: '[int]',
     *             DAYS_0000_TO_1970: '[long]',
     *             year: '[int]',
     *             month: '[short]',
     *             day: '[short]'
     *         }
     * Return dto:
     *     {
     *         reportExists: '[boolean]'
     *     }
     */
    ExciceDutyReportExistsQueryHandler_handle(localDate) {
        return this.apiClient.invoke('ExciceDutyReportExistsQueryHandler', 'handle', { localDate: localDate });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         reports: {
     *             id: '[ExciseReportId]',
     *             createdDateTime: '[String]',
     *             period: '[String]',
     *             ytdIn: '[BigDecimal]',
     *             ytdOut: '[BigDecimal]',
     *             movementCount: '[int]'
     *         }
     *     }
     */
    ExciseDutyReportListQueryHandler_handle() {
        return this.apiClient.invoke('ExciseDutyReportListQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             period: '[YearMonth]',
     *             comment: '[String]',
     *             y2dInOverride: '[BigDecimal]'
     *         }
     * Return dto:
     *     {
     *         report: '[ExciseDutyReportDto]',
     *         existingReportCount: '[int]',
     *         movementsWithDutyClassificationsForAlcohol: {
     *             id: '[MovementId]',
     *             movementType: '[MovementType]',
     *             revertedBy: '[MovementId]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             date: '[LocalDate]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingName: '[String]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             classification: '[ExciseDutyClassificationDto]'
     *         },
     *         movementsWithDutyClassificationsForEnvironmentPackaging: {
     *             id: '[MovementId]',
     *             movementType: '[MovementType]',
     *             revertedBy: '[MovementId]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             date: '[LocalDate]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingName: '[String]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             classification: '[ExciseDutyClassificationDto]'
     *         },
     *         movementsWithDutyClassificationsForBasePackaging: {
     *             id: '[MovementId]',
     *             movementType: '[MovementType]',
     *             revertedBy: '[MovementId]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             date: '[LocalDate]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingName: '[String]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             classification: '[ExciseDutyClassificationDto]'
     *         },
     *         movementsWithDutyClassificationsForNonAlcoholicBeverages: {
     *             id: '[MovementId]',
     *             movementType: '[MovementType]',
     *             revertedBy: '[MovementId]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             date: '[LocalDate]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingName: '[String]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             classification: '[ExciseDutyClassificationDto]'
     *         }
     *     }
     */
    ExciseDutyReportPreviewQueryHandler_handle(query) {
        return this.apiClient.invoke('ExciseDutyReportPreviewQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     exciseReportId:
     *         {

     *         }
     * Return dto:
     *     {
     *         report: '[ExciseDutyReportDto]',
     *         movementsWithDutyClassificationsForAlcohol: {
     *             id: '[MovementId]',
     *             movementType: '[MovementType]',
     *             revertedBy: '[MovementId]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             date: '[LocalDate]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingName: '[String]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             classification: '[ExciseDutyClassificationDto]'
     *         },
     *         movementsWithDutyClassificationsForEnvironmentPackaging: {
     *             id: '[MovementId]',
     *             movementType: '[MovementType]',
     *             revertedBy: '[MovementId]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             date: '[LocalDate]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingName: '[String]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             classification: '[ExciseDutyClassificationDto]'
     *         },
     *         movementsWithDutyClassificationsForBasePackaging: {
     *             id: '[MovementId]',
     *             movementType: '[MovementType]',
     *             revertedBy: '[MovementId]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             date: '[LocalDate]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingName: '[String]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             classification: '[ExciseDutyClassificationDto]'
     *         },
     *         movementsWithDutyClassificationsForNonAlcoholicBeverages: {
     *             id: '[MovementId]',
     *             movementType: '[MovementType]',
     *             revertedBy: '[MovementId]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             date: '[LocalDate]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingName: '[String]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             classification: '[ExciseDutyClassificationDto]'
     *         }
     *     }
     */
    ExciseDutyReportQueryHandler_handle(exciseReportId) {
        return this.apiClient.invoke('ExciseDutyReportQueryHandler', 'handle', { exciseReportId: exciseReportId });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             invoiceIds: {

     *             }
     *         }
     * Return dto:
     *     {
     *         fileBase64: '[String]',
     *         filename: '[String]'
     *     }
     */
    ExportInvoicesCommandHandler_handle(command) {
        return this.apiClient.invoke('ExportInvoicesCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {

     *         }
     * Return dto:
     *     {
     *         files: {
     *             path: '[String]',
     *             content: '[String]',
     *             isDirectory: '[boolean]'
     *         }
     *     }
     */
    FakeSftpContentQueryHandler_handle(query) {
        return this.apiClient.invoke('FakeSftpContentQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             period: '[YearMonth]',
     *             comment: '[String]',
     *             y2dInOverride: '[BigDecimal]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    GenerateExciseDutyReportCommandHandler_handle(command) {
        return this.apiClient.invoke('GenerateExciseDutyReportCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             yearMonth: '[YearMonth]'
     *         }
     * Return dto:
     *     {
     *         lines: {
     *             description: '[String]',
     *             fromAbvInclusive: '[BigDecimal]',
     *             toAbvInclusive: '[BigDecimal]',
     *             sumQuantity: '[BigDecimal]'
     *         }
     *     }
     */
    HealthDirectorateReportQueryHandler_handle(query) {
        return this.apiClient.invoke('HealthDirectorateReportQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     period:
     *         {
     *             serialVersionUID: '[long]',
     *             PARSER: '[DateTimeFormatter]',
     *             year: '[int]',
     *             month: '[int]'
     *         }
     * Return dto:
     *     {
     *         lines: {
     *             rowNumber: '[int]',
     *             gtinConsumerPackaging: '[String]',
     *             panteSats: '[PanteSats]',
     *             productName: '[String]',
     *             quantity: '[int]'
     *         }
     *     }
     */
    InfinitumReportQueryHandler_handle(period) {
        return this.apiClient.invoke('InfinitumReportQueryHandler', 'handle', { period: period });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             date: '[LocalDate]',
     *             storageAreaId: '[StorageAreaId]'
     *         }
     * Return dto:
     *     {
     *         storageAreas: {
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             storageAreaApproved: '[Boolean]',
     *             totalCostPrice: '[Money]',
     *             lines: {
     *                 lineId: '[String]',
     *                 articleId: '[ArticleId]',
     *                 articleNumber: '[String]',
     *                 batchId: '[BatchId]',
     *                 batchNumber: '[Integer]',
     *                 productId: '[ProductId]',
     *                 productName: '[String]',
     *                 packagingId: '[PackagingId]',
     *                 packagingName: '[String]',
     *                 fractionalVolume: '[BigDecimal]',
     *                 quantity: '[int]',
     *                 unitCostPrice: '[Money]',
     *                 totalCostPrice: '[Money]'
     *             }
     *         },
     *         articleMissingCostPriceCount: '[long]',
     *         articleWithNegativeInventoryCount: '[long]'
     *     }
     */
    InventoryAccountingValueQueryHandler_handle(query) {
        return this.apiClient.invoke('InventoryAccountingValueQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             year: '[int]'
     *         }
     * Return dto:
     *     {
     *         storageAreas: {
     *             name: '[String]',
     *             isApproved: '[boolean]',
     *             groups: {
     *                 dutyClassification: '[String]',
     *                 items: {
     *                     storageAreaId: '[StorageAreaId]',
     *                     articleId: '[ArticleId]',
     *                     articleNumber: '[String]',
     *                     articleName: '[String]',
     *                     batchId: '[BatchId]',
     *                     batchNumber: '[Integer]',
     *                     dutyDto: '[DutyKey]',
     *                     shortageOffsetQuantity: '[Integer]',
     *                     surplusOffsetQuantity: '[Integer]',
     *                     netSurplusOffsetQuantity: '[Integer]',
     *                     shortageOffsetQuantityConverted: '[Integer]',
     *                     surplusOffsetQuantityConverted: '[Integer]',
     *                     shortageOffsetQuantityOriginal: '[Integer]',
     *                     surplusOffsetQuantityOriginal: '[Integer]',
     *                     netSurplusOffsetQuantityOriginal: '[Integer]'
     *                 },
     *                 sumShortageOffsetQuantity: '[Integer]',
     *                 sumSurplusOffsetQuantity: '[Integer]',
     *                 sumNetSurplusOffsetQuantity: '[Integer]',
     *                 sumShortageOffsetQuantityConverted: '[Integer]',
     *                 sumSurplusOffsetQuantityConverted: '[Integer]',
     *                 sumShortageOffsetQuantityOriginal: '[Integer]',
     *                 sumSurplusOffsetQuantityOriginal: '[Integer]',
     *                 sumNetSurplusOffsetQuantityOriginal: '[Integer]',
     *                 balance: '[Integer]'
     *             }
     *         }
     *     }
     */
    InventoryOffsetQueryHandler_handle(query) {
        return this.apiClient.invoke('InventoryOffsetQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         years: {
     *             year: '[String]'
     *         }
     *     }
     */
    InventoryOffsetYearsQueryHandler_handle() {
        return this.apiClient.invoke('InventoryOffsetYearsQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             storageAreaId: '[StorageAreaId]',
     *             date: '[LocalDate]',
     *             includeArticlesWithEmptyInventory: '[boolean]'
     *         }
     * Return dto:
     *     {
     *         storageAreas: {
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             storageAreaApproved: '[Boolean]',
     *             lines: {
     *                 lineId: '[String]',
     *                 articleId: '[ArticleId]',
     *                 articleNumber: '[String]',
     *                 batchId: '[BatchId]',
     *                 batchNumber: '[String]',
     *                 productId: '[ProductId]',
     *                 productName: '[String]',
     *                 packagingId: '[PackagingId]',
     *                 packagingName: '[String]',
     *                 fractionalVolume: '[BigDecimal]',
     *                 quantity: '[int]',
     *                 liter: '[BigDecimal]',
     *                 crateCount: '[int]',
     *                 crateCountRemainder: '[int]',
     *                 expiryDate: '[LocalDate]'
     *             }
     *         }
     *     }
     */
    InventoryReportQueryHandler_handle(query) {
        return this.apiClient.invoke('InventoryReportQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             invoiceId: '[InvoiceId]'
     *         }
     * Return dto:
     *     {
     *         invoice: '[InvoiceDetailsQueryResultEntity]',
     *         documentRenderings: {
     *             documentRenderingId: '[DocumentRenderingId]',
     *             createdDateTime: '[LocalDateTime]',
     *             filename: '[String]',
     *             mimeType: '[String]'
     *         }
     *     }
     */
    InvoiceDetailsQueryHandler_handle(query) {
        return this.apiClient.invoke('InvoiceDetailsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             orderId: '[OrderId]',
     *             invoiceNumber: '[String]'
     *         }
     * Return dto:
     *     void
     */
    InvoiceOrderCommandHandler_handle(command) {
        return this.apiClient.invoke('InvoiceOrderCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             fromDateInclusive: '[LocalDate]',
     *             toDateInclusive: '[LocalDate]',
     *             customerId: '[CustomerId]',
     *             invoiceNumber: '[String]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             invoiceId: '[InvoiceId]',
     *             bundled: '[boolean]',
     *             createdDateTime: '[String]',
     *             orderId: '[OrderId]',
     *             invoiceNumber: '[String]',
     *             isCreditNote: '[boolean]',
     *             originalInvoiceNumber: '[String]',
     *             invoiceDate: '[LocalDate]',
     *             dueDate: '[LocalDate]',
     *             customersReference: '[String]',
     *             customerId: '[CustomerId]',
     *             customerNumber: '[String]',
     *             customerName: '[String]',
     *             totalExtVat: '[Money]',
     *             totalIncVat: '[Money]',
     *             sentStatus: '[SentStatus]',
     *             additionalFields: {
     *                 deduplicationId: '[String]',
     *                 key: '[String]',
     *                 value: '[String]'
     *             }
     *         }
     *     }
     */
    InvoicesForAccountingIndexQueryHandler_handle(query) {
        return this.apiClient.invoke('InvoicesForAccountingIndexQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     roleId:
     *         {

     *         }
     *     permission:
     *         {
     *             id: '[String]'
     *         }
     * Return dto:
     *     void
     */
    LocalPermissionService_addPermissionToRole(roleId, permission) {
        return this.apiClient.invoke('LocalPermissionService', 'addPermissionToRole', { roleId: roleId, permission: permission });
    }

    /**
     * Parameter dto:
     *     roleId:
     *         {

     *         }
     *     permissions:
     *         {

     *         }
     * Return dto:
     *     void
     */
    LocalPermissionService_addPermissionsToRole(roleId, permissions) {
        return this.apiClient.invoke('LocalPermissionService', 'addPermissionsToRole', { roleId: roleId, permissions: permissions });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_createAuthenticatedUserRole() {
        return this.apiClient.invoke('LocalPermissionService', 'createAuthenticatedUserRole', {  });
    }

    /**
     * Parameter dto:
     *     name:
     *         {
     *             value: '[byte[]]',
     *             coder: '[byte]',
     *             hash: '[int]',
     *             hashIsZero: '[boolean]',
     *             serialVersionUID: '[long]',
     *             COMPACT_STRINGS: '[boolean]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             REPL: '[char]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]',
     *             LATIN1: '[byte]',
     *             UTF16: '[byte]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_createRole(name) {
        return this.apiClient.invoke('LocalPermissionService', 'createRole', { name: name });
    }

    /**
     * Parameter dto:
     *     roleId:
     *         {

     *         }
     *     name:
     *         {
     *             value: '[byte[]]',
     *             coder: '[byte]',
     *             hash: '[int]',
     *             hashIsZero: '[boolean]',
     *             serialVersionUID: '[long]',
     *             COMPACT_STRINGS: '[boolean]',
     *             serialPersistentFields: '[ObjectStreamField[]]',
     *             REPL: '[char]',
     *             CASE_INSENSITIVE_ORDER: '[Comparator]',
     *             LATIN1: '[byte]',
     *             UTF16: '[byte]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_createRoleWithId(roleId, name) {
        return this.apiClient.invoke('LocalPermissionService', 'createRoleWithId', { roleId: roleId, name: name });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_getAllRoles() {
        return this.apiClient.invoke('LocalPermissionService', 'getAllRoles', {  });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_getAllUsers() {
        return this.apiClient.invoke('LocalPermissionService', 'getAllUsers', {  });
    }

    /**
     * Parameter dto:
     *     uuid:
     *         {
     *             serialVersionUID: '[long]',
     *             mostSigBits: '[long]',
     *             leastSigBits: '[long]',
     *             jla: '[JavaLangAccess]',
     *             NIBBLES: '[byte[]]',
     *             $assertionsDisabled: '[boolean]'
     *         }
     * Return dto:
     *     {
     *         permissions: '[Map]'
     *     }
     */
    LocalPermissionService_getClaims(uuid) {
        return this.apiClient.invoke('LocalPermissionService', 'getClaims', { uuid: uuid });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         permissions: '[Map]'
     *     }
     */
    LocalPermissionService_getMyClaims() {
        return this.apiClient.invoke('LocalPermissionService', 'getMyClaims', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             permissionArgumentTypes: {
     *                 id: '[String]'
     *             }
     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_getPermissionArgumentOptions(query) {
        return this.apiClient.invoke('LocalPermissionService', 'getPermissionArgumentOptions', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_getPermissions() {
        return this.apiClient.invoke('LocalPermissionService', 'getPermissions', {  });
    }

    /**
     * Parameter dto:
     *     roleId:
     *         {

     *         }
     * Return dto:
     *     {
     *         name: '[String]',
     *         permissions: {
     *             permissionType: '[PermissionTypeDto]',
     *             hasPermission: '[boolean]'
     *         }
     *     }
     */
    LocalPermissionService_getRoleWithPermissions(roleId) {
        return this.apiClient.invoke('LocalPermissionService', 'getRoleWithPermissions', { roleId: roleId });
    }

    /**
     * Parameter dto:
     *     userId:
     *         {

     *         }
     * Return dto:
     *     {
     *         userId: '[UserId]',
     *         name: '[String]'
     *     }
     */
    LocalPermissionService_getUserDetails(userId) {
        return this.apiClient.invoke('LocalPermissionService', 'getUserDetails', { userId: userId });
    }

    /**
     * Parameter dto:
     *     userId:
     *         {

     *         }
     * Return dto:
     *     {
     *         id: '[UserId]',
     *         grants: {
     *             grantId: '[GrantId]',
     *             roleId: '[RoleId]',
     *             roleName: '[String]',
     *             arguments: {
     *                 argumentType: '[PermissionArgumentType]',
     *                 argumentValue: '[String]'
     *             }
     *         }
     *     }
     */
    LocalPermissionService_getUserWithGrants(userId) {
        return this.apiClient.invoke('LocalPermissionService', 'getUserWithGrants', { userId: userId });
    }

    /**
     * Parameter dto:
     *     roleId:
     *         {

     *         }
     *     userId:
     *         {

     *         }
     *     permissionArguments:
     *         {
     *             permissionArguments: '[Set]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_grantRoleToUser(roleId, userId, permissionArguments) {
        return this.apiClient.invoke('LocalPermissionService', 'grantRoleToUser', { roleId: roleId, userId: userId, permissionArguments: permissionArguments });
    }

    /**
     * Parameter dto:
     *     roleId:
     *         {

     *         }
     *     userId:
     *         {

     *         }
     *     permissionArguments:
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    LocalPermissionService_grantRoleToUserWithJavaArgs(roleId, userId, permissionArguments) {
        return this.apiClient.invoke('LocalPermissionService', 'grantRoleToUserWithJavaArgs', { roleId: roleId, userId: userId, permissionArguments: permissionArguments });
    }

    /**
     * Parameter dto:
     *     userId:
     *         {

     *         }
     * Return dto:
     *     void
     */
    LocalPermissionService_newUserWasCreated(userId) {
        return this.apiClient.invoke('LocalPermissionService', 'newUserWasCreated', { userId: userId });
    }

    /**
     * Parameter dto:
     *     grantId:
     *         {

     *         }
     * Return dto:
     *     void
     */
    LocalPermissionService_revokeGrant(grantId) {
        return this.apiClient.invoke('LocalPermissionService', 'revokeGrant', { grantId: grantId });
    }

    /**
     * Parameter dto:
     *     roleId:
     *         {

     *         }
     *     role:
     *         {
     *             name: '[String]',
     *             permissions: {
     *                 permissionType: '[PermissionTypeDto]',
     *                 hasPermission: '[boolean]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    LocalPermissionService_setRolePermissions(roleId, role) {
        return this.apiClient.invoke('LocalPermissionService', 'setRolePermissions', { roleId: roleId, role: role });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         materials: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    MaterialsForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('MaterialsForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             productId: '[ProductId]'
     *         }
     * Return dto:
     *     {
     *         breweryMax: '[String]',
     *         productMax: '[String]'
     *     }
     */
    MaxArticleNumberQueryHandler_handle(query) {
        return this.apiClient.invoke('MaxArticleNumberQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             orderId: '[OrderId]',
     *             movementDate: '[LocalDate]'
     *         }
     * Return dto:
     *     void
     */
    MoveGoodsFromStorageForOrderCommandHandler_handle(command) {
        return this.apiClient.invoke('MoveGoodsFromStorageForOrderCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     movementId:
     *         {

     *         }
     * Return dto:
     *     {
     *         movement: '[MovementDetailsDto]',
     *         sameMovementGroup: {
     *             movementId: '[MovementId]',
     *             originalMovementId: '[MovementId]',
     *             movementDate: '[LocalDate]',
     *             movementType: '[MovementType]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingId: '[PackagingId]',
     *             packagingName: '[String]',
     *             productId: '[ProductId]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchId: '[BatchId]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             correspondingSalePeriod: '[String]',
     *             invoiceNumber: '[String]',
     *             createdBy: '[UserId]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             createdDateTime: '[String]',
     *             editable: '[Boolean]',
     *             movementGroupId: '[MovementGroupId]',
     *             revertedBy: '[MovementId]',
     *             replacedBy: '[MovementId]',
     *             transferContraEntryMovementId: '[MovementId]',
     *             comment: '[String]',
     *             order: '[MovementDetailsOrderDto]'
     *         },
     *         sameOriginalMovement: {
     *             movementId: '[MovementId]',
     *             originalMovementId: '[MovementId]',
     *             movementDate: '[LocalDate]',
     *             movementType: '[MovementType]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             packagingId: '[PackagingId]',
     *             packagingName: '[String]',
     *             productId: '[ProductId]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             batchId: '[BatchId]',
     *             batchNumber: '[Integer]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             correspondingSalePeriod: '[String]',
     *             invoiceNumber: '[String]',
     *             createdBy: '[UserId]',
     *             firstName: '[String]',
     *             lastName: '[String]',
     *             createdDateTime: '[String]',
     *             editable: '[Boolean]',
     *             movementGroupId: '[MovementGroupId]',
     *             revertedBy: '[MovementId]',
     *             replacedBy: '[MovementId]',
     *             transferContraEntryMovementId: '[MovementId]',
     *             comment: '[String]',
     *             order: '[MovementDetailsOrderDto]'
     *         }
     *     }
     */
    MovementDetailsQueryHandler_handle(movementId) {
        return this.apiClient.invoke('MovementDetailsQueryHandler', 'handle', { movementId: movementId });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             movementGroupId: '[MovementGroupId]'
     *         }
     * Return dto:
     *     {
     *         movementGroup: '[MovementGroupDetailsQueryResultEntity]',
     *         allMovementsReverted: '[boolean]'
     *     }
     */
    MovementGroupDetailsQueryHandler_handle(query) {
        return this.apiClient.invoke('MovementGroupDetailsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     movementQuery:
     *         {
     *             storageAreaId: '[StorageAreaId]',
     *             fromDateInclusive: '[LocalDate]',
     *             toDateInclusive: '[LocalDate]',
     *             productId: '[ProductId]',
     *             customerId: '[CustomerId]',
     *             movementType: '[MovementType]',
     *             articleId: '[ArticleId]',
     *             batchId: '[BatchId]'
     *         }
     * Return dto:
     *     {
     *         movements: {
     *             id: '[MovementId]',
     *             originalMovementId: '[MovementId]',
     *             movementGroupId: '[MovementGroupId]',
     *             createdDateTime: '[LocalDateTime]',
     *             movementType: '[MovementType]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             date: '[LocalDate]',
     *             articleId: '[ArticleId]',
     *             quantity: '[int]',
     *             customerId: '[CustomerId]',
     *             packagingName: '[String]',
     *             batchId: '[BatchId]',
     *             batchNumber: '[Integer]',
     *             articleNumber: '[String]',
     *             productName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             customerName: '[String]',
     *             invoiceNumber: '[String]',
     *             revertedBy: '[MovementId]',
     *             transferContraEntryMovementId: '[MovementId]',
     *             editable: '[Boolean]'
     *         }
     *     }
     */
    MovementQueryHandler_handle(movementQuery) {
        return this.apiClient.invoke('MovementQueryHandler', 'handle', { movementQuery: movementQuery });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         nonAlcoholicBeverageDutyGroupCodes: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    NonAlcoholicBeverageDutyGroupCodesForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('NonAlcoholicBeverageDutyGroupCodesForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderConfirmationId: '[OrderConfirmationId]'
     *         }
     * Return dto:
     *     {
     *         orderConfirmation: '[OrderConfirmationDetailsQueryResultEntity]',
     *         documentRenderings: {
     *             documentRenderingId: '[DocumentRenderingId]',
     *             createdDateTime: '[LocalDateTime]',
     *             filename: '[String]',
     *             mimeType: '[String]'
     *         }
     *     }
     */
    OrderConfirmationDetailsQueryHandler_handle(query) {
        return this.apiClient.invoke('OrderConfirmationDetailsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderId: '[OrderId]',
     *             orderDocumentIdType: '[OrderDocumentIdType]',
     *             orderDocumentId: '[UUID]'
     *         }
     * Return dto:
     *     {
     *         order: '[OrderDetailsQueryResultEntity]',
     *         orderPolicy: '[OrderPolicy]'
     *     }
     */
    OrderDetailsQueryHandler_handle(query) {
        return this.apiClient.invoke('OrderDetailsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderId: '[OrderId]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             type: '[OrderDocumentType]',
     *             id: '[UUID]',
     *             isSent: '[Boolean]',
     *             number: '[String]',
     *             date: '[LocalDate]',
     *             createdDateTime: '[LocalDateTime]',
     *             negativeStatus: '[Boolean]',
     *             linesWithoutOrderLineReference: '[Long]',
     *             openProblemCount: '[int]',
     *             orderSource: '[OrderSource]'
     *         }
     *     }
     */
    OrderDocumentListQueryHandler_handle(query) {
        return this.apiClient.invoke('OrderDocumentListQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     orderId:
     *         {

     *         }
     *     dto:
     *         {
     *             orderId: '[OrderId]',
     *             orderType: '[OrderType]',
     *             orderDate: '[LocalDate]',
     *             customerId: '[CustomerId]',
     *             customersReference: '[String]',
     *             storageAreaId: '[StorageAreaId]',
     *             saleType: '[SaleType]',
     *             isDutyFree: '[Boolean]',
     *             correspondingSalePeriod: '[String]',
     *             lines: {
     *                 orderLineId: '[OrderLineId]',
     *                 productId: '[ProductId]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]'
     *             },
     *             freetextLines: {
     *                 orderFreetextLineId: '[OrderFreetextLineId]',
     *                 freetext: '[String]',
     *                 quantity: '[int]'
     *             },
     *             commentFromCustomer: '[String]',
     *             commentForCustomer: '[String]',
     *             commentForInternalUse: '[String]'
     *         }
     * Return dto:
     *     void
     */
    OrderEditCommandHandler_edit(orderId, dto) {
        return this.apiClient.invoke('OrderEditCommandHandler', 'edit', { orderId: orderId, dto: dto });
    }

    /**
     * Parameter dto:
     *     orderId:
     *         {

     *         }
     * Return dto:
     *     {
     *         orderId: '[OrderId]',
     *         orderSource: '[OrderSource]',
     *         orderEditDto: '[OrderEditDto]'
     *     }
     */
    OrderEditCommandHandler_getForEdit(orderId) {
        return this.apiClient.invoke('OrderEditCommandHandler', 'getForEdit', { orderId: orderId });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderStep: '[OrderStep]',
     *             onlyCancelled: '[boolean]',
     *             orderType: '[OrderType]',
     *             fromDateInclusive: '[LocalDate]',
     *             toDateInclusive: '[LocalDate]',
     *             customerId: '[CustomerId]',
     *             invoiceNumber: '[String]'
     *         }
     * Return dto:
     *     {
     *         orders: {
     *             orderId: '[OrderId]',
     *             orderNumber: '[String]',
     *             customersReference: '[String]',
     *             deliveryShortDescription: '[String]',
     *             orderType: '[OrderType]',
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             customerNumber: '[String]',
     *             orderDate: '[LocalDate]',
     *             lineCount: '[int]',
     *             isCancelled: '[boolean]',
     *             goodsHaveBeenMoved: '[boolean]',
     *             invoiceNumber: '[String]',
     *             orderConfirmationSent: '[boolean]',
     *             deliveryNoteSent: '[boolean]',
     *             proofOfDeliveryReceived: '[boolean]',
     *             invoiceSent: '[boolean]'
     *         }
     *     }
     */
    OrderIndexQueryHandler_handle(query) {
        return this.apiClient.invoke('OrderIndexQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         orderTypes: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    OrderTypesForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('OrderTypesForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             orderId: '[OrderId]',
     *             newOrderStep: '[OrderStep]'
     *         }
     * Return dto:
     *     void
     */
    OverrideOrderStepCommandHandler_handle(command) {
        return this.apiClient.invoke('OverrideOrderStepCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             name: '[String]',
     *             exciseDuty: '[boolean]',
     *             material: '[Material]',
     *             packagingType: '[PackagingType]',
     *             brod2PackagingType: '[Brod2PackagingType]',
     *             recyclingScheme: '[RecyclingScheme]',
     *             volume: '[BigDecimal]',
     *             quantityPrCrate: '[int]',
     *             panteSats: '[PanteSats]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    PackagingCrud_create(dto) {
        return this.apiClient.invoke('PackagingCrud', 'create', { dto: dto });
    }

    /**
     * Parameter dto:
     *     packagingId:
     *         {

     *         }
     * Return dto:
     *     {
     *         packagingId: '[PackagingId]',
     *         name: '[String]',
     *         exciseDuty: '[boolean]',
     *         material: '[Material]',
     *         packagingType: '[PackagingType]',
     *         brod2PackagingType: '[Brod2PackagingType]',
     *         recyclingScheme: '[RecyclingScheme]',
     *         volume: '[BigDecimal]',
     *         quantityPrCrate: '[int]',
     *         panteSats: '[PanteSats]'
     *     }
     */
    PackagingCrud_details(packagingId) {
        return this.apiClient.invoke('PackagingCrud', 'details', { packagingId: packagingId });
    }

    /**
     * Parameter dto:
     *     packagingId:
     *         {

     *         }
     *     dto:
     *         {
     *             packagingId: '[PackagingId]',
     *             name: '[String]',
     *             exciseDuty: '[boolean]',
     *             material: '[Material]',
     *             packagingType: '[PackagingType]',
     *             brod2PackagingType: '[Brod2PackagingType]',
     *             recyclingScheme: '[RecyclingScheme]',
     *             volume: '[BigDecimal]',
     *             quantityPrCrate: '[int]',
     *             panteSats: '[PanteSats]'
     *         }
     * Return dto:
     *     void
     */
    PackagingCrud_edit(packagingId, dto) {
        return this.apiClient.invoke('PackagingCrud', 'edit', { packagingId: packagingId, dto: dto });
    }

    /**
     * Parameter dto:
     *     packagingId:
     *         {

     *         }
     * Return dto:
     *     {
     *         packagingId: '[PackagingId]',
     *         packagingEditDto: '[PackagingEditDto]',
     *         canEditMaterial: '[boolean]',
     *         canEditRecyclingScheme: '[boolean]',
     *         canEditVolume: '[boolean]'
     *     }
     */
    PackagingCrud_getForEdit(packagingId) {
        return this.apiClient.invoke('PackagingCrud', 'getForEdit', { packagingId: packagingId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    PackagingCrud_index() {
        return this.apiClient.invoke('PackagingCrud', 'index', {  });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         packaging: {
     *             id: '[PackagingId]',
     *             name: '[String]'
     *         }
     *     }
     */
    PackagingForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('PackagingForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderId: '[OrderId]',
     *             deliveryNoteId: '[DeliveryNoteId]'
     *         }
     * Return dto:
     *     {
     *         orderId: '[OrderId]',
     *         orderNumber: '[String]',
     *         customersOrderReference: '[String]',
     *         orderDate: '[LocalDate]',
     *         printDate: '[LocalDate]',
     *         fromParty: '[PackagingSlipPartyDto]',
     *         toParty: '[PackagingSlipPartyDto]',
     *         comment: '[String]',
     *         lines: {
     *             lineId: '[String]',
     *             lineNumber: '[int]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             articleName: '[String]',
     *             batchId: '[BatchId]',
     *             batchNumber: '[String]',
     *             productId: '[ProductId]',
     *             productName: '[String]',
     *             packagingId: '[PackagingId]',
     *             packagingName: '[String]',
     *             fractionalVolume: '[BigDecimal]',
     *             quantity: '[int]',
     *             crateCount: '[int]',
     *             crateCountRemainder: '[int]'
     *         },
     *         freetextLines: {
     *             id: '[OrderFreetextLineId]',
     *             sortOrder: '[int]',
     *             freetext: '[String]',
     *             quantity: '[int]'
     *         }
     *     }
     */
    PackagingSlipQueryHandler_handle(query) {
        return this.apiClient.invoke('PackagingSlipQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         packagingTypes: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    PackagingTypesForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('PackagingTypesForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     customerId:
     *         {

     *         }
     *     saleDate:
     *         {
     *             MIN: '[LocalDate]',
     *             MAX: '[LocalDate]',
     *             EPOCH: '[LocalDate]',
     *             serialVersionUID: '[long]',
     *             DAYS_PER_CYCLE: '[int]',
     *             DAYS_0000_TO_1970: '[long]',
     *             year: '[int]',
     *             month: '[short]',
     *             day: '[short]'
     *         }
     * Return dto:
     *     {
     *         hasValidPermitOnDate: '[boolean]',
     *         shouldHavePermit: '[boolean]'
     *     }
     */
    PermitValidityQueryHandler_handle(customerId, saleDate) {
        return this.apiClient.invoke('PermitValidityQueryHandler', 'handle', { customerId: customerId, saleDate: saleDate });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             referenceIdType: '[ReferenceIdType]',
     *             referenceId: '[UUID]'
     *         }
     * Return dto:
     *     {
     *         newExplicitActionableItems: {
     *             explicitActionableItemId: '[ExplicitActionableItemId]',
     *             type: '[ExplicitActionableItemType]',
     *             status: '[ExplicitActionItemStatus]',
     *             message: '[String]',
     *             registerDateTime: '[String]',
     *             referenceIdType: '[ReferenceIdType]',
     *             referenceId: '[UUID]',
     *             displayIdType: '[DisplayIdType]',
     *             displayId: '[String]',
     *             doneDateTime: '[String]',
     *             canRetry: '[boolean]',
     *             canClose: '[boolean]'
     *         },
     *         doneExplicitActionableItems: {
     *             explicitActionableItemId: '[ExplicitActionableItemId]',
     *             type: '[ExplicitActionableItemType]',
     *             status: '[ExplicitActionItemStatus]',
     *             message: '[String]',
     *             registerDateTime: '[String]',
     *             referenceIdType: '[ReferenceIdType]',
     *             referenceId: '[UUID]',
     *             displayIdType: '[DisplayIdType]',
     *             displayId: '[String]',
     *             doneDateTime: '[String]',
     *             canRetry: '[boolean]',
     *             canClose: '[boolean]'
     *         },
     *         articlesInvisibleInCustomerPortal: {
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             articleName: '[String]'
     *         }
     *     }
     */
    ProblemListQueryHandler_handle(query) {
        return this.apiClient.invoke('ProblemListQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         MIN_VALUE: '[int]',
     *         MAX_VALUE: '[int]',
     *         TYPE: '[Class]',
     *         digits: '[char[]]',
     *         DigitTens: '[byte[]]',
     *         DigitOnes: '[byte[]]',
     *         value: '[int]',
     *         SIZE: '[int]',
     *         BYTES: '[int]',
     *         serialVersionUID: '[long]'
     *     }
     */
    ProblemListQueryHandler_unResolvedProblemCount() {
        return this.apiClient.invoke('ProblemListQueryHandler', 'unResolvedProblemCount', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             productId: '[ProductId]'
     *         }
     * Return dto:
     *     {
     *         articles: {
     *             id: '[ArticleId]',
     *             name: '[String]',
     *             quantityPrCrate: '[Integer]',
     *             batchTracking: '[boolean]'
     *         }
     *     }
     */
    ProductArticlesForDropdownQueryHandler_handle(query) {
        return this.apiClient.invoke('ProductArticlesForDropdownQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             productId: '[ProductId]',
     *             storageAreaId: '[StorageAreaId]'
     *         }
     * Return dto:
     *     {
     *         articles: {
     *             id: '[ArticleId]',
     *             name: '[String]',
     *             inStock: '[Long]',
     *             reserved: '[Long]',
     *             quantityPrCrate: '[Integer]',
     *             batchTracking: '[boolean]'
     *         }
     *     }
     */
    ProductArticlesWithInventoryForDropdownQueryHandler_handle(query) {
        return this.apiClient.invoke('ProductArticlesWithInventoryForDropdownQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             name: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    ProductCategoryCrud_create(dto) {
        return this.apiClient.invoke('ProductCategoryCrud', 'create', { dto: dto });
    }

    /**
     * Parameter dto:
     *     productCategoryId:
     *         {

     *         }
     * Return dto:
     *     {
     *         productCategoryId: '[ProductCategoryId]',
     *         name: '[String]'
     *     }
     */
    ProductCategoryCrud_details(productCategoryId) {
        return this.apiClient.invoke('ProductCategoryCrud', 'details', { productCategoryId: productCategoryId });
    }

    /**
     * Parameter dto:
     *     productCategoryId:
     *         {

     *         }
     *     dto:
     *         {
     *             productCategoryId: '[ProductCategoryId]',
     *             name: '[String]'
     *         }
     * Return dto:
     *     void
     */
    ProductCategoryCrud_edit(productCategoryId, dto) {
        return this.apiClient.invoke('ProductCategoryCrud', 'edit', { productCategoryId: productCategoryId, dto: dto });
    }

    /**
     * Parameter dto:
     *     productCategoryId:
     *         {

     *         }
     * Return dto:
     *     {
     *         productCategoryId: '[ProductCategoryId]',
     *         productCategoryEditDto: '[ProductCategoryEditDto]'
     *     }
     */
    ProductCategoryCrud_getForEdit(productCategoryId) {
        return this.apiClient.invoke('ProductCategoryCrud', 'getForEdit', { productCategoryId: productCategoryId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    ProductCategoryCrud_index() {
        return this.apiClient.invoke('ProductCategoryCrud', 'index', {  });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             productCategoryId: '[ProductCategoryId]',
     *             name: '[String]',
     *             abv: '[BigDecimal]',
     *             beverageType: '[BeverageType]',
     *             isCarbonated: '[boolean]',
     *             containsSugar: '[boolean]',
     *             containsArtificialSweeteners: '[boolean]',
     *             isEnergyDrink: '[boolean]',
     *             isWithTaste: '[boolean]',
     *             brod2ProductCategory: '[Brod2ProductCategory]',
     *             brod2BeerCalorieType: '[Brod2BeerCalorieType]',
     *             brod2SodaTaste: '[Brod2SodaTaste]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    ProductCrud_create(dto) {
        return this.apiClient.invoke('ProductCrud', 'create', { dto: dto });
    }

    /**
     * Parameter dto:
     *     productId:
     *         {

     *         }
     * Return dto:
     *     {
     *         productId: '[ProductId]',
     *         productCategoryId: '[ProductCategoryId]',
     *         name: '[String]',
     *         productCategoryName: '[String]',
     *         abv: '[BigDecimal]',
     *         beverageType: '[BeverageType]',
     *         isCarbonated: '[boolean]',
     *         containsSugar: '[boolean]',
     *         containsArtificialSweeteners: '[boolean]',
     *         isEnergyDrink: '[boolean]',
     *         isWithTaste: '[boolean]',
     *         brod2ProductCategory: '[Brod2ProductCategory]',
     *         brod2BeerCalorieType: '[Brod2BeerCalorieType]',
     *         brod2SodaTaste: '[Brod2SodaTaste]'
     *     }
     */
    ProductCrud_details(productId) {
        return this.apiClient.invoke('ProductCrud', 'details', { productId: productId });
    }

    /**
     * Parameter dto:
     *     productId:
     *         {

     *         }
     *     dto:
     *         {
     *             productId: '[ProductId]',
     *             productCategoryId: '[ProductCategoryId]',
     *             name: '[String]',
     *             abv: '[BigDecimal]',
     *             beverageType: '[BeverageType]',
     *             isCarbonated: '[boolean]',
     *             containsSugar: '[boolean]',
     *             containsArtificialSweeteners: '[boolean]',
     *             isEnergyDrink: '[boolean]',
     *             isWithTaste: '[boolean]',
     *             brod2ProductCategory: '[Brod2ProductCategory]',
     *             brod2BeerCalorieType: '[Brod2BeerCalorieType]',
     *             brod2SodaTaste: '[Brod2SodaTaste]'
     *         }
     * Return dto:
     *     void
     */
    ProductCrud_edit(productId, dto) {
        return this.apiClient.invoke('ProductCrud', 'edit', { productId: productId, dto: dto });
    }

    /**
     * Parameter dto:
     *     productId:
     *         {

     *         }
     * Return dto:
     *     {
     *         productId: '[ProductId]',
     *         productEditDto: '[ProductEditDto]',
     *         canEditAbv: '[boolean]',
     *         canEditBeverageType: '[boolean]'
     *     }
     */
    ProductCrud_getForEdit(productId) {
        return this.apiClient.invoke('ProductCrud', 'getForEdit', { productId: productId });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {

     *     }
     */
    ProductCrud_index() {
        return this.apiClient.invoke('ProductCrud', 'index', {  });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         products: {
     *             id: '[ProductId]',
     *             name: '[String]'
     *         }
     *     }
     */
    ProductsForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('ProductsForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             proofOfDeliveryId: '[ProofOfDeliveryId]'
     *         }
     * Return dto:
     *     {
     *         proofOfDelivery: '[ProofOfDeliveryDetailsQueryResultEntity]'
     *     }
     */
    ProofOfDeliveryDetailsQueryHandler_handle(query) {
        return this.apiClient.invoke('ProofOfDeliveryDetailsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         rangeOverrides: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    RangeOverridesForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('RangeOverridesForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             logData: '[String]',
     *             stackTrace: '[String]',
     *             locationHref: '[String]'
     *         }
     * Return dto:
     *     void
     */
    RecordFrontendLogCommandHandler_handle(command) {
        return this.apiClient.invoke('RecordFrontendLogCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         recyclingSchemes: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    RecyclingSchemesForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('RecyclingSchemesForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             customerId: '[CustomerId]'
     *         }
     * Return dto:
     *     void
     */
    RefreshCustomerPeppolStatusCommandHandler_handle(command) {
        return this.apiClient.invoke('RefreshCustomerPeppolStatusCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {

     *         }
     * Return dto:
     *     void
     */
    RefreshVmpStoreCacheCommandHandler_handle(command) {
        return this.apiClient.invoke('RefreshVmpStoreCacheCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     destructionCommand:
     *         {
     *             date: '[LocalDate]',
     *             storageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    RegisterDestructionCommandHandler_destruction(destructionCommand) {
        return this.apiClient.invoke('RegisterDestructionCommandHandler', 'destruction', { destructionCommand: destructionCommand });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             orderDocumentType: '[OrderDocumentType]',
     *             id: '[UUID]'
     *         }
     * Return dto:
     *     {
     *         command: '[CreateMovementGroupCommandTemplate]'
     *     }
     */
    RegisterMovementsFromOrderCommandHandler_getTemplate(query) {
        return this.apiClient.invoke('RegisterMovementsFromOrderCommandHandler', 'getTemplate', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             orderId: '[OrderId]',
     *             storageAreaId: '[StorageAreaId]',
     *             date: '[LocalDate]',
     *             saleType: '[SaleType]',
     *             isDutyFree: '[boolean]',
     *             correspondingSalePeriod: '[String]',
     *             lines: {
     *                 orderLineId: '[OrderLineId]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]'
     *             }
     *         }
     * Return dto:
     *     {

     *     }
     */
    RegisterMovementsFromOrderCommandHandler_handle(command) {
        return this.apiClient.invoke('RegisterMovementsFromOrderCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     tappingCommand:
     *         {
     *             date: '[LocalDate]',
     *             storageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    RegisterOpeningBalanceCommandHandler_openingBalance(tappingCommand) {
        return this.apiClient.invoke('RegisterOpeningBalanceCommandHandler', 'openingBalance', { tappingCommand: tappingCommand });
    }

    /**
     * Parameter dto:
     *     registerSaleCommand:
     *         {
     *             orderType: '[OrderType]',
     *             date: '[LocalDate]',
     *             customerId: '[CustomerId]',
     *             customersReference: '[String]',
     *             storageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]'
     *             },
     *             freetextLines: {
     *                 freetext: '[String]',
     *                 quantity: '[int]'
     *             },
     *             saleType: '[SaleType]',
     *             isDutyFree: '[Boolean]',
     *             correspondingSalePeriod: '[String]',
     *             commentFromCustomer: '[String]',
     *             commentForCustomer: '[String]',
     *             commentForInternalUse: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    RegisterOrderCommandHandler_handle(registerSaleCommand) {
        return this.apiClient.invoke('RegisterOrderCommandHandler', 'handle', { registerSaleCommand: registerSaleCommand });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             date: '[LocalDate]',
     *             storageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             },
     *             isPreTaxed: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    RegisterReceivedGoodsCommandHandler_handle(command) {
        return this.apiClient.invoke('RegisterReceivedGoodsCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             date: '[LocalDate]',
     *             customerId: '[CustomerId]',
     *             storageAreaId: '[StorageAreaId]',
     *             isDutyFree: '[boolean]',
     *             correspondingSalePeriod: '[String]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             },
     *             invoiceNumber: '[String]'
     *         }
     * Return dto:
     *     void
     */
    RegisterReturnedGoodsCommandHandler_handle(command) {
        return this.apiClient.invoke('RegisterReturnedGoodsCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     registerSaleCommand:
     *         {
     *             date: '[LocalDate]',
     *             customerId: '[CustomerId]',
     *             storageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             },
     *             saleType: '[SaleType]',
     *             invoiceNumber: '[String]'
     *         }
     * Return dto:
     *     void
     */
    RegisterSaleCommandHandler_sale(registerSaleCommand) {
        return this.apiClient.invoke('RegisterSaleCommandHandler', 'sale', { registerSaleCommand: registerSaleCommand });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             saleItems: {
     *                 date: '[LocalDate]',
     *                 customerId: '[CustomerId]',
     *                 storageAreaId: '[StorageAreaId]',
     *                 lines: {
     *                     rowNumber: '[Integer]',
     *                     articleId: '[ArticleId]',
     *                     batchId: '[BatchId]',
     *                     quantity: '[int]',
     *                     comment: '[String]'
     *                 },
     *                 saleType: '[SaleType]',
     *                 invoiceNumber: '[String]'
     *             },
     *             returnItems: {
     *                 date: '[LocalDate]',
     *                 customerId: '[CustomerId]',
     *                 storageAreaId: '[StorageAreaId]',
     *                 isDutyFree: '[boolean]',
     *                 correspondingSalePeriod: '[String]',
     *                 lines: {
     *                     rowNumber: '[Integer]',
     *                     articleId: '[ArticleId]',
     *                     batchId: '[BatchId]',
     *                     quantity: '[int]',
     *                     comment: '[String]'
     *                 },
     *                 invoiceNumber: '[String]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    RegisterSaleCommandHandler_saleMultiple(command) {
        return this.apiClient.invoke('RegisterSaleCommandHandler', 'saleMultiple', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             date: '[LocalDate]',
     *             storageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    RegisterSentGoodsCommandHandler_handle(command) {
        return this.apiClient.invoke('RegisterSentGoodsCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     shortageCommand:
     *         {
     *             date: '[LocalDate]',
     *             storageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             },
     *             movementTypeOffset: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    RegisterShortageCommandHandler_shortage(shortageCommand) {
        return this.apiClient.invoke('RegisterShortageCommandHandler', 'shortage', { shortageCommand: shortageCommand });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             year: '[int]',
     *             shortageLines: {
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]',
     *                 storageAreaId: '[StorageAreaId]'
     *             },
     *             surplusLines: {
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]',
     *                 storageAreaId: '[StorageAreaId]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    RegisterShortageConversionCommandHandler_handle(command) {
        return this.apiClient.invoke('RegisterShortageConversionCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     surplusCommand:
     *         {
     *             date: '[LocalDate]',
     *             storageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             },
     *             movementTypeOffset: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    RegisterSurplusCommandHandler_handle(surplusCommand) {
        return this.apiClient.invoke('RegisterSurplusCommandHandler', 'handle', { surplusCommand: surplusCommand });
    }

    /**
     * Parameter dto:
     *     tappingCommand:
     *         {
     *             date: '[LocalDate]',
     *             storageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    RegisterTappingCommandHandler_tapping(tappingCommand) {
        return this.apiClient.invoke('RegisterTappingCommandHandler', 'tapping', { tappingCommand: tappingCommand });
    }

    /**
     * Parameter dto:
     *     registerTransferCommand:
     *         {
     *             date: '[LocalDate]',
     *             fromStorageAreaId: '[StorageAreaId]',
     *             toStorageAreaId: '[StorageAreaId]',
     *             lines: {
     *                 rowNumber: '[Integer]',
     *                 articleId: '[ArticleId]',
     *                 batchId: '[BatchId]',
     *                 quantity: '[int]',
     *                 comment: '[String]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    RegisterTransferCommandHandler_transfer(registerTransferCommand) {
        return this.apiClient.invoke('RegisterTransferCommandHandler', 'transfer', { registerTransferCommand: registerTransferCommand });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             invoiceId: '[InvoiceId]',
     *             invoiceType: '[InvoiceType]'
     *         }
     * Return dto:
     *     void
     */
    RenderInvoiceCommandHandler_handle(command) {
        return this.apiClient.invoke('RenderInvoiceCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         reportingPeriodYears: {
     *             id: '[Year]',
     *             name: '[String]'
     *         }
     *     }
     */
    ReportingPeriodYearsForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('ReportingPeriodYearsForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         reportingPeriods: {
     *             id: '[YearMonth]',
     *             name: '[String]'
     *         }
     *     }
     */
    ReportingPeriodsForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('ReportingPeriodsForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             explicitActionableItemId: '[ExplicitActionableItemId]'
     *         }
     * Return dto:
     *     void
     */
    RetryExplicitActionableItemCommandHandler_handle(command) {
        return this.apiClient.invoke('RetryExplicitActionableItemCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             movementGroupId: '[MovementGroupId]',
     *             comment: '[String]'
     *         }
     * Return dto:
     *     void
     */
    RevertMovementGroupCommandHandler_handle(command) {
        return this.apiClient.invoke('RevertMovementGroupCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         saleTypes: {
     *             id: '[String]',
     *             name: '[String]'
     *         }
     *     }
     */
    SaleTypesForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('SaleTypesForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             fromDateInclusive: '[LocalDate]',
     *             toDateInclusive: '[LocalDate]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             movementId: '[MovementId]',
     *             movementType: '[MovementType]',
     *             date: '[LocalDate]',
     *             storageAreaId: '[StorageAreaId]',
     *             storageAreaName: '[String]',
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             articleName: '[String]',
     *             productId: '[ProductId]',
     *             productName: '[String]',
     *             packagingId: '[PackagingId]',
     *             packagingName: '[String]',
     *             batchId: '[BatchId]',
     *             batchNumber: '[Integer]',
     *             customerId: '[CustomerId]',
     *             customerNumber: '[String]',
     *             customerName: '[String]',
     *             customerType: '[CustomerType]',
     *             quantity: '[int]',
     *             packagingVolume: '[BigDecimal]',
     *             totalVolume: '[BigDecimal]',
     *             invoiceNumber: '[String]'
     *         }
     *     }
     */
    SalesStatisticsBaseDataQueryHandler_handle(query) {
        return this.apiClient.invoke('SalesStatisticsBaseDataQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             fromDateInclusive: '[LocalDate]',
     *             toDateInclusive: '[LocalDate]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             articleId: '[ArticleId]',
     *             articleNumber: '[String]',
     *             articleName: '[String]',
     *             packagingId: '[PackagingId]',
     *             packagingName: '[String]',
     *             quantitySale: '[int]',
     *             quantityReturn: '[int]',
     *             quantityNetSale: '[int]',
     *             litersSale: '[BigDecimal]',
     *             litersReturn: '[BigDecimal]',
     *             litersNetSale: '[BigDecimal]'
     *         }
     *     }
     */
    SalesStatisticsByArticleQueryHandler_handle(query) {
        return this.apiClient.invoke('SalesStatisticsByArticleQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             fromDateInclusive: '[LocalDate]',
     *             toDateInclusive: '[LocalDate]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             customerId: '[CustomerId]',
     *             customerNumber: '[String]',
     *             customerName: '[String]',
     *             quantitySale: '[int]',
     *             quantityReturn: '[int]',
     *             quantityNetSale: '[int]',
     *             litersSale: '[BigDecimal]',
     *             litersReturn: '[BigDecimal]',
     *             litersNetSale: '[BigDecimal]'
     *         }
     *     }
     */
    SalesStatisticsByCustomerQueryHandler_handle(query) {
        return this.apiClient.invoke('SalesStatisticsByCustomerQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             fromDateInclusive: '[LocalDate]',
     *             toDateInclusive: '[LocalDate]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             rowNumber: '[int]',
     *             productCategoryId: '[ProductCategoryId]',
     *             productCategoryName: '[String]',
     *             quantitySale: '[int]',
     *             quantityReturn: '[int]',
     *             quantityNetSale: '[int]',
     *             litersSale: '[BigDecimal]',
     *             litersReturn: '[BigDecimal]',
     *             litersNetSale: '[BigDecimal]'
     *         }
     *     }
     */
    SalesStatisticsByProductCategoryQueryHandler_handle(query) {
        return this.apiClient.invoke('SalesStatisticsByProductCategoryQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             fromDateInclusive: '[LocalDate]',
     *             toDateInclusive: '[LocalDate]'
     *         }
     * Return dto:
     *     {
     *         items: {
     *             yearMonth: '[YearMonth]',
     *             quantitySale: '[int]',
     *             quantityReturn: '[int]',
     *             quantityNetSale: '[int]',
     *             litersSale: '[BigDecimal]',
     *             litersReturn: '[BigDecimal]',
     *             litersNetSale: '[BigDecimal]'
     *         }
     *     }
     */
    SalesStatisticsByYearMonthQueryHandler_handle(query) {
        return this.apiClient.invoke('SalesStatisticsByYearMonthQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             rules: {
     *                 key: '[ArticlePriceRuleKey]',
     *                 price: '[Money]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    SaveArticlePriceListCommandHandler_handle(command) {
        return this.apiClient.invoke('SaveArticlePriceListCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             deliveryNoteId: '[DeliveryNoteId]'
     *         }
     * Return dto:
     *     void
     */
    SendDeliveryNoteCommandHandler_handle(command) {
        return this.apiClient.invoke('SendDeliveryNoteCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             invoiceId: '[InvoiceId]'
     *         }
     * Return dto:
     *     void
     */
    SendInvoiceCommandHandler_handle(command) {
        return this.apiClient.invoke('SendInvoiceCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             orderId: '[OrderId]',
     *             force: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    SendLegacyOrderConfirmationCommandHandler_handle(command) {
        return this.apiClient.invoke('SendLegacyOrderConfirmationCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             orderConfirmationId: '[OrderConfirmationId]'
     *         }
     * Return dto:
     *     void
     */
    SendOrderConfirmationCommandHandler_handle(command) {
        return this.apiClient.invoke('SendOrderConfirmationCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             year: '[int]',
     *             customers: {
     *                 customerId: '[CustomerId]'
     *             }
     *         }
     * Return dto:
     *     void
     */
    SendYearlySalesReportsCommandHandler_handle(command) {
        return this.apiClient.invoke('SendYearlySalesReportsCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             articleId: '[ArticleId]',
     *             active: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    SetArticleActiveStatusCommandHandler_handle(command) {
        return this.apiClient.invoke('SetArticleActiveStatusCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     command:
     *         {
     *             batchId: '[BatchId]',
     *             active: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    SetBatchActiveStatusCommandHandler_handle(command) {
        return this.apiClient.invoke('SetBatchActiveStatusCommandHandler', 'handle', { command: command });
    }

    /**
     * Parameter dto:
     *     dto:
     *         {
     *             name: '[String]',
     *             approvedStorageArea: '[boolean]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]'
     *         }
     * Return dto:
     *     {

     *     }
     */
    StorageAreaCrud_create(dto) {
        return this.apiClient.invoke('StorageAreaCrud', 'create', { dto: dto });
    }

    /**
     * Parameter dto:
     *     storageAreaId:
     *         {

     *         }
     * Return dto:
     *     {
     *         storageAreaId: '[StorageAreaId]',
     *         name: '[String]',
     *         approvedStorageArea: '[boolean]',
     *         streetAddress: '[String]',
     *         postalCode: '[String]',
     *         city: '[String]',
     *         active: '[boolean]'
     *     }
     */
    StorageAreaCrud_details(storageAreaId) {
        return this.apiClient.invoke('StorageAreaCrud', 'details', { storageAreaId: storageAreaId });
    }

    /**
     * Parameter dto:
     *     storageAreaId:
     *         {

     *         }
     *     dto:
     *         {
     *             storageAreaId: '[StorageAreaId]',
     *             name: '[String]',
     *             approvedStorageArea: '[boolean]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]',
     *             active: '[boolean]'
     *         }
     * Return dto:
     *     void
     */
    StorageAreaCrud_edit(storageAreaId, dto) {
        return this.apiClient.invoke('StorageAreaCrud', 'edit', { storageAreaId: storageAreaId, dto: dto });
    }

    /**
     * Parameter dto:
     *     storageAreaId:
     *         {

     *         }
     * Return dto:
     *     {
     *         storageAreaId: '[StorageAreaId]',
     *         storageAreaEditDto: '[StorageAreaEditDto]',
     *         canEditApprovalFlag: '[boolean]'
     *     }
     */
    StorageAreaCrud_getForEdit(storageAreaId) {
        return this.apiClient.invoke('StorageAreaCrud', 'getForEdit', { storageAreaId: storageAreaId });
    }

    /**
     * Parameter dto:
     *     showInactiveStorageAreas:
     *         {

     *         }
     * Return dto:
     *     {

     *     }
     */
    StorageAreaCrud_index(showInactiveStorageAreas) {
        return this.apiClient.invoke('StorageAreaCrud', 'index', { showInactiveStorageAreas: showInactiveStorageAreas });
    }

    /**
     * Parameter dto:
     *     <none>
     * Return dto:
     *     {
     *         storageAreas: {
     *             id: '[StorageAreaId]',
     *             name: '[String]'
     *         }
     *     }
     */
    StorageAreasForDropdownQueryHandler_handle() {
        return this.apiClient.invoke('StorageAreasForDropdownQueryHandler', 'handle', {  });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             yearMonth: '[YearMonth]'
     *         }
     * Return dto:
     *     {
     *         period: '[YearMonth]',
     *         storageAreas: {
     *             id: '[StorageAreaId]',
     *             name: '[String]',
     *             articles: {
     *                 id: '[ArticleId]',
     *                 articleNumber: '[String]',
     *                 productName: '[String]',
     *                 packagingName: '[String]',
     *                 fractionalVolume: '[String]',
     *                 abv: '[BigDecimal]',
     *                 movements: {
     *                     id: '[MovementId]',
     *                     date: '[LocalDate]',
     *                     movementType: '[MovementType]',
     *                     customerType: '[CustomerType]',
     *                     customerName: '[String]',
     *                     additionalCode: '[String]',
     *                     quantity: '[int]',
     *                     liter: '[BigDecimal]',
     *                     invoiceNumber: '[String]'
     *                 },
     *                 openingBalanceQuantity: '[int]',
     *                 openingBalanceLiter: '[BigDecimal]',
     *                 closingBalanceQuantity: '[int]',
     *                 closingBalanceLiter: '[BigDecimal]'
     *             },
     *             totalOpeningBalanceLiters: '[BigDecimal]',
     *             totalClosingBalanceLiters: '[BigDecimal]'
     *         }
     *     }
     */
    StoragePrArticleQueryHandler_handle(query) {
        return this.apiClient.invoke('StoragePrArticleQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             yearMonth: '[YearMonth]',
     *             showInactiveArticles: '[boolean]'
     *         }
     * Return dto:
     *     {
     *         period: '[YearMonth]',
     *         storageAreas: {
     *             id: '[StorageAreaId]',
     *             name: '[String]',
     *             approvedStorageArea: '[boolean]',
     *             streetAddress: '[String]',
     *             postalCode: '[String]',
     *             city: '[String]',
     *             lines: {
     *                 generatedId: '[String]',
     *                 storageAreaId: '[StorageAreaId]',
     *                 articleId: '[ArticleId]',
     *                 articleNumber: '[String]',
     *                 packagingMaterial: '[Material]',
     *                 productVolume: '[BigDecimal]',
     *                 productName: '[String]',
     *                 packagingName: '[String]',
     *                 fractionalVolume: '[String]',
     *                 movementCount: '[int]',
     *                 abv: '[BigDecimal]',
     *                 openingBalance: '[int]',
     *                 openingBalanceExternal: '[int]',
     *                 tapping: '[int]',
     *                 retur: '[int]',
     *                 returDutyFree: '[int]',
     *                 surplus: '[int]',
     *                 surplusOffset: '[int]',
     *                 transferInDutyFree: '[int]',
     *                 receivedGoods: '[int]',
     *                 receivedGoodsPreTaxed: '[int]',
     *                 saleCustomerWithAdditionalCode: '[int]',
     *                 otherSales: '[int]',
     *                 saleLiquorLicence: '[int]',
     *                 saleVinmonopolet: '[int]',
     *                 saleEmployeesAndOwners: '[int]',
     *                 productSample: '[int]',
     *                 shortage: '[int]',
     *                 shortageOffset: '[int]',
     *                 transferOutDutyFree: '[int]',
     *                 salgDutyFree: '[int]',
     *                 sentGoods: '[int]',
     *                 destruction: '[int]',
     *                 closingBalance: '[int]'
     *             }
     *         }
     *     }
     */
    SummaryReportQueryHandler_handle(query) {
        return this.apiClient.invoke('SummaryReportQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             yearMonth: '[YearMonth]',
     *             showInactiveArticles: '[boolean]'
     *         }
     * Return dto:
     *     {
     *         fileBase64: '[String]',
     *         filename: '[String]'
     *     }
     */
    SummaryReportQueryHandler_handleExcel(query) {
        return this.apiClient.invoke('SummaryReportQueryHandler', 'handleExcel', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             transferId: '[TransferId]'
     *         }
     * Return dto:
     *     {
     *         transferId: '[TransferId]',
     *         transferNumber: '[String]',
     *         bundleItems: {
     *             invoiceId: '[InvoiceId]',
     *             createdDateTime: '[String]',
     *             orderId: '[OrderId]',
     *             invoiceNumber: '[String]',
     *             isCreditNote: '[boolean]',
     *             originalInvoiceNumber: '[String]',
     *             invoiceDate: '[LocalDate]',
     *             dueDate: '[LocalDate]',
     *             customersReference: '[String]',
     *             customerId: '[CustomerId]',
     *             customerNumber: '[String]',
     *             customerName: '[String]',
     *             totalExtVat: '[Money]',
     *             totalIncVat: '[Money]',
     *             sentStatus: '[SentStatus]',
     *             additionalFields: {
     *                 deduplicationId: '[String]',
     *                 key: '[String]',
     *                 value: '[String]'
     *             }
     *         }
     *     }
     */
    TransferDetailsQueryHandler_handle(query) {
        return this.apiClient.invoke('TransferDetailsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {

     *         }
     * Return dto:
     *     {
     *         items: {
     *             transferId: '[TransferId]',
     *             destination: '[InvoiceExportFormat]',
     *             referenceType: '[TransferReferenceType]',
     *             reference: '[UUID]',
     *             bundleStatus: '[BundleStatus]',
     *             bundleItemCount: '[Long]',
     *             transferNumber: '[String]',
     *             periodKey: '[String]',
     *             invoiceId: '[InvoiceId]',
     *             invoiceNumber: '[String]'
     *         }
     *     }
     */
    TransferIndexQueryHandler_handle(query) {
        return this.apiClient.invoke('TransferIndexQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {

     *         }
     * Return dto:
     *     {
     *         customerIdForCustomerPortal: '[CustomerId]'
     *     }
     */
    UserInfoQueryHandler_handle(query) {
        return this.apiClient.invoke('UserInfoQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {

     *         }
     * Return dto:
     *     {
     *         available: '[boolean]'
     *     }
     */
    VmpTestToolsQueryHandler_handle(query) {
        return this.apiClient.invoke('VmpTestToolsQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             year: '[Year]'
     *         }
     * Return dto:
     *     {
     *         customers: {
     *             customerId: '[CustomerId]',
     *             customerName: '[String]',
     *             customerEmail: '[String]',
     *             customerShouldHaveYearlyReportOnEmail: '[boolean]',
     *             alreadySent: '[boolean]',
     *             litersTotal: '[BigDecimal]',
     *             litersGroup1: '[BigDecimal]',
     *             litersGroup2: '[BigDecimal]',
     *             litersGroup3: '[BigDecimal]'
     *         }
     *     }
     */
    YearlyCustomerReportQueryHandler_handle(query) {
        return this.apiClient.invoke('YearlyCustomerReportQueryHandler', 'handle', { query: query });
    }

    /**
     * Parameter dto:
     *     query:
     *         {
     *             year: '[Year]'
     *         }
     * Return dto:
     *     {
     *         litersTotal: '[BigDecimal]',
     *         litersGroup1: '[BigDecimal]',
     *         litersGroup2: '[BigDecimal]',
     *         litersGroup3: '[BigDecimal]'
     *     }
     */
    YearlyLiquorLicenseReportQueryHandler_handle(query) {
        return this.apiClient.invoke('YearlyLiquorLicenseReportQueryHandler', 'handle', { query: query });
    }
}
